import React, { useEffect, useState } from "react";
import { Icon, Pagination, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import Filter from "../../components/layout/UpdateHistory/Filter";
import "./UpdateHistory.css";
import Card from "../../components/layout/UpdateHistory/Card";

const SuperMedia = (props) => {
  const [totalPages, setTotalPages] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [data, setData] = useState([]);

  useEffect(() => {
    let todaysData = [];

    if (props.media && props.media.length > 0) {
      todaysData = [...props.media];
    }

    const paginated =
      todaysData && todaysData.slice((activePage - 1) * 10, activePage * 10);
    setTotalPages(Math.ceil(todaysData.length / 10));
    setData(paginated);
  }, [props.media, activePage]);
  if (data) {
    const pageChange = (not, data) => {
      setActivePage(data.activePage);
    };
    return (
      <div className="AthleteDetailsBackground cu-profile update-history wiki-section height-100">
        <div className="AthleteDetailsBannerBar"></div>
        <Filter />
        <div className="AthleteEventsInfoContainer common-event">
          <div
            className={`testimonial-section super-media super-update-history ${
              data && (data.length < 2 ? "onlyone" : "")
            }`}
          >
            {data && data.length < 1 && (
              <p className="not-found cu-center">There's No Data Right Now</p>
            )}

            <div className="testimonial-col team-section">
              {data &&
                data.length > 0 &&
                data.map((e) => (
                  <Card data={e} superAdmin={props.superAdmin} />
                ))}
            </div>
          </div>
        </div>

        {/* pagination and pages show */}
        {totalPages > 1 && (
          <div className="AthleteSearchDetail AthletePagination justify-center">
            <Pagination
              onPageChange={pageChange}
              activePag={activePage}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{
                content: <Icon name="angle right" />,
                icon: true,
              }}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>
        )}
        {/* AddSchoolsToWatch */}
      </div>
    );
  } else
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
};

const mapStateToProps = (state) => {
  let updateData = [];
  updateData = state.firestore.ordered.updateReport;
  const thisMonth = new Date().getMonth();
  if (updateData && updateData.length > 0) {
    updateData = updateData.filter(
      (e) => e?.new && Object.keys(e?.new).length > 0
    );
    updateData = updateData
      .filter((e) => e?.new?.modifiedAt.toDate().getMonth() >= thisMonth - 1)
      .sort((a, b) => b?.new?.modifiedAt - a?.new?.modifiedAt);
  }
  return {
    media: updateData,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "updateReport",
      },
      {
        collection: "mediaOrder",
      },
    ];
    return firestoreArray;
  })
)(SuperMedia);
